const Header = {
    WebAppVersion: 'Templafy-WebApp-Version',
    CSRF: 'x-csrf-token'
};
const CSRF_TOKEN_COOKIE_NAME = '__Host-Csrf-Token';
export { CSRF_TOKEN_COOKIE_NAME, Header };
